import { formatUIDate } from 'utils/helpers'
import { DailyReportReportPayloadItem, DailyReportReportTableItem } from '../interfaces'

export const toTableRowItems = (
  items: DailyReportReportPayloadItem[]
): DailyReportReportTableItem[] =>
  items.map(item => ({
    id: item.id,
    reportNo: item.reportNo ?? '',
    creationDate: formatUIDate(item.date),
    categories: item.categories.filter(c => c) ?? [],
    companies: item.companies.filter(c => c) ?? [],
    storeName: item.storeName ?? '',
    measuredWeight: +item.measuredWeight,
    totalCalculatedWeight: +item.totalCalculatedWeight,
    legalEntityName: item.legalEntity ?? '',
    reportUploadStatus: item.reportUploadStatus ?? null,
    documentNo: item.documentNo ?? 0,
    isCompanyReport: item.isCompanyReport,
    isReportSigned: item.isReportSigned,
    metiReports: item.metiReports ?? []
  }))
